<template>
<div style="margin-bottom: 100px">

    <vue-headful title="Articles" />

    <v-container fluid style="background-color: #f5f5f5;" :class="{ 'px-1': $vuetify.breakpoint.smAndDown, 'pt-3': true}">
        <v-row no-gutters>
            <!-- place filter-->
            <v-col cols="6" md="3" class="px-1">
                <v-card class="mb-3 elevation-1 pa-1">
                    <div class="detail font-weight-bold pa-0 ma-0">Place</div>
                    <im-place-search class="im-select ma-0" solo placeholder="Any" @input="filterLocation($event)" hide-details />
                </v-card>
            </v-col>
            <!--./ place filter-->
            <!-- section filter-->
            <v-col cols="6" md="2" class="px-1">
                <v-card class="mb-3 elevation-1 pa-1">
                    <div class="detail font-weight-bold pa-0 ma-0">Section</div>
                    <v-select class="im-select pa-0 ma-0" :items="sections" v-model="filter_section_id" item-text="title.ro" item-value="id" flat solo clearable placeholder="Any ..." @input="filterArticles()" />
                </v-card>
            </v-col>
            <!--./ section filter-->
            <!-- lang filter-->
            <v-col cols="6" md="2" class="px-1">
                <v-card class="mb-3 elevation-1 pa-1">
                    <div class="detail font-weight-bold pa-0 ma-0">Language</div>
                    <v-select class="im-select pa-0 ma-0" flat solo v-model="language" :items="language_items" item-text="text" item-value="value" placeholder="Any" clearable :menu-props="{transition:'scale-transition', 'offset-y': ''}" @input="filterArticles()"
                        hide-details />
                </v-card>
            </v-col>
            <!--./ lang filter-->
            <!-- status filter-->
            <v-col cols="6" md="2" class="px-1">
                <v-card class="mb-3 elevation-1 pa-1">
                    <div class="detail font-weight-bold pa-0 ma-0">Status</div>
                    <v-select class="im-select pa-0 ma-0" flat solo v-model="status" :items="status_items" placeholder="Any" clearable :menu-props="{transition:'scale-transition', 'offset-y': ''}" @input="filterArticles()" hide-details />

                </v-card>
            </v-col>
            <!--./ status filter-->
            <!-- author filter-->
            <v-col cols="6" md="3" class="px-1">
                <v-card class="mb-3 elevation-1 pa-1">
                    <div class="detail font-weight-bold pa-0 ma-0">Author</div>
                    <im-user-search class="im-select ma-0" placeholder="Type here to select ..." @input="filterUser($event)" hide-details />

                </v-card>
            </v-col>
            <!--./ author filter-->
        </v-row>

        <!-- SEARCH -->
        <div class="im-search mt-3 mb-1">
            <div class="d-flex">
                <v-text-field class="ma-0 mx-1 white pt-0" flat v-model="search" clearable placeholder="Type here to search by field ..." append-icon="search" hide-details></v-text-field>
                <v-icon medium v-if="$vuetify.breakpoint.smAndDown" class="px-1" @click="dialog_mobile_sort = true">swap_vert
                </v-icon>
            </div>
            <div class="d-flex mx-1 py-2 fields align-center">
                <span class="detail mr-1 hidden-sm-and-down">Find in:</span>
                <v-btn v-for="field in search_fields" :key="field.value" small rounded depressed class="detail mx-1" :color="field.selected ? 'primary' : 'grey lighten-2'" :text-color="field.selected ? 'white' : 'grey'" @click="selectField(field)">
                    <span class="text-capitalize">{{field.text}}</span>
                </v-btn>
            </div>
        </div>
        <!-- ./ SEARCH -->

        <!--data table-->
        <v-card tile flat class="mx-1">
            <im-table-header :items="im_header" @clickSort="sortField($event)" />
        </v-card>
        <!--./ data table -->
        <div class="mx-1" style="position: relative; height: 3px">
            <v-progress-linear v-if="loading" indeterminate height="3" class="pa-0 ma-0" color="primary" style="position: absolute" />
        </div>

        <!-- DATATABLE ROWS -->
        <v-card tile flat style="background-color: transparent !important;" class="mx-1">
            <v-data-iterator :items="items" :page.sync="page" :items-per-page.sync="size" :server-items-length="total" :footer-props="{ itemsPerPageOptions }">
                <template v-slot:default="props">
                    <template v-for="item in props.items">
                        <im-article-item :item="item" @click.native="seeItem(item)" />
                    </template>
                </template>
                <template v-slot:no-data>
                    <v-alert :value="true" type="info" color="primary">
                        No data available.
                    </v-alert>
                </template>
            </v-data-iterator>


        </v-card>

        <!-- ./ article card -->
    </v-container>
    <!-- add button -->
    <v-btn color="primary" @click="openCreate()" fab large fixed bottom right>
        <v-icon>add</v-icon>
    </v-btn>
    <!-- ./ add button -->

    <im-article-modal-edit :dialog="edit_dialog" :id="item_id" @refresh="getArticles()" @exit="item_id =null,edit_dialog= false" />

    <!-- place modal dialog -->
    <v-dialog v-model="article_dialog" max-width="850px" :fullscreen="$vuetify.breakpoint.smAndDown" persistent :overlay="false" transition="dialog-transition">
        <v-card>
            <v-card flat tile>
                <v-card-title class="headline p-2">
                    Article Details
                    <v-spacer />
                    <v-btn icon left @click="article_dialog=false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>
            </v-card>
            <im-article-modal :item="current_article"></im-article-modal>
            <v-card-actions>
                <v-btn dark color="red" @click="openDeleteModal(current_article)">Delete</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="article_dialog=false , openEdit(current_article)">Edit</v-btn>
                <v-btn text @click="article_dialog = false">Cancel</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- place modal dialog -->

    <!--delete dialog-->
    <v-dialog v-model="delete_dialog" max-width="320">
        <v-card>
            <v-card-text>
                Are you sure you want to delete this article?
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn dark color="red" :loading="loading_delete" @click="destroy()">
                    Delete
                </v-btn>
                <v-btn color="primary" text @click="delete_dialog=false">
                    Cancel
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!--./delete dialog -->

</div>
</template>

<script>
import {
    mapActions
} from 'vuex'
import IMArticleItem from '../components/items/ArticleCard.vue'
import IMPlaceSearch from '../components/utils/IMPlaceSearch.vue'
import IMUserSearch from '../components/utils/UserSearch.vue'
import IMSectionSearch from '../components/utils/SectionSearch.vue'

import defaults from "../components/utils/PropDefaults.js";
import IMTableHeader from '../components/utils/IMTableHeader.vue';
import IMSortField from "../components/utils/IMSortField.vue";
import IMArticleModalView from '../components/items/ArticleModalView.vue';
import IMArticleModalEdit from '../components/items/ArticleModalEdit.vue';
import TipTap from "../components/utils/TipTap2.vue";


export default {

    name: `articles`,

    components: {
        'im-article-item': IMArticleItem,
        'im-place-search': IMPlaceSearch,
        'im-user-search': IMUserSearch,
        'im-section-search': IMSectionSearch,
        'im-table-header': IMTableHeader,
        'im-sort-filed': IMSortField,
        'im-article-modal': IMArticleModalView,
        'im-article-modal-edit': IMArticleModalEdit,
        'tip-tap': TipTap,
    },

    data() {
        return {
            edit_dialog: false,
            item_id: null,
            old_photos: [],
            photos: [],
            dialog_photo: false,
            current_photo: defaults.photo_item,
            current_key: null,
            loading_save: false,
            loading_delete: false,

            filter_location_id: null,
            filter_section_ids: null,

            // dialogs
            add_dialog: false,
            delete_dialog: false,
            article_dialog: false,
            current_article: defaults.article_item,

            // search
            search: null,
            search_ids: null,
            search_place_ids: null,
            search_section_ids: null,
            search_user_ids: null,

            // filter items
            section: null,
            filter_section_id: null,
            sections: [],
            language: null,
            languages: ['ro'],
            author: null,
            authors: ['1'],

            //search-fields
            search_fields: [
                {
                    text: 'Id',
                    value: 'id',
                    selected: false
                }, {
                    text: 'Title',
                    value: 'title',
                    selected: true
                }, {
                    text: 'Body',
                    value: 'body',
                    selected: false
                }, {
                    text: 'Author',
                    value: 'author',
                    selected: true
                }
            ],

            //table header
            im_header: [
                {
                    text: "Place",
                    sortable: false,
                    sort_dir: null,
                    align: "left",
                    width: "6%"
                }, {
                    text: "Section",
                    sortable: false,
                    sort_dir: null,
                    align: "left",
                    width: "10%"
                }, {
                    text: "Title",
                    sortable: true,
                    sort_dir: null,
                    sort_order: "title",
                    align: "left",
                    width: "49%"
                }, {
                    text: "Create date",
                    sortable: true,
                    sort_dir: null,
                    sort_order: "created_at",
                    align: "left",
                    width: "9%"
                }, {
                    text: "C",
                    sortable: true,
                    sort_dir: null,
                    sort_order: "comment_sum",
                    align: "left",
                    width: "2%"
                }, {
                    text: "R",
                    sortable: true,
                    sort_dir: null,
                    sort_order: "rating_avg",
                    align: "left",
                    width: "2%"
                }, {
                    text: "O",
                    sortable: true,
                    sort_dir: null,
                    sort_order: "order",
                    align: "left",
                    width: "2%"
                }, {
                    text: "User",
                    sortable: false,
                    sort_dir: null,
                    align: "center",
                    width: "20%"
                }
            ],

            sort_field_item: null,
            sort_field_dir: null,
            dialog_mobile_sort: false,

            search_filter: ['title'],
            search_sort: {
                rating_avg: null,
                comment_sum: null,
                order: 'order',
            },
            search_dir: {
                rating_avg: 'desc',
                comment_sum: 'desc',
                order: 'desc',
            },
            search_order: [{
                search_sort: 'order',
                search_dir: 'desc'
            }],

            // article model
            article: {
                id: null,
                place: {
                    id: null,
                    name: null
                },
                place_id: null,
                user: {
                    id: null,
                    name: null,
                    email: null
                },
                user_id: null,
                section_id: null,
                title: null,
                body: null,
                status: 'pending',
                language: 'en',
                order: 50
            },



            //languages
            language_items: [
                {
                    text: "English",
                    value: "en"
                }, {
                    text: "Romanian",
                    value: "ro"
                }
            ],

            // status filter
            status: null,
            status_items: [
                {
                    text: "Approved",
                    value: "approved"
                }, {
                    text: "Pending",
                    value: "pending"
                }, {
                    text: "Rejected",
                    value: "rejected"
                }
            ],

            // table items
            items: [],

            // table attributes
            search_timeout: 300,
            loading: null,
            total: 0,
            page: 1,
            size: 10,
            itemsPerPageOptions: [10, 25, 50, 100],

            linkUrl: null,
            linkMenuIsActive: false
        }
    },

    watch: {

        page: {
            handler() {
                this.getArticles()
            }
        },
        size: {
            handler() {
                this.getArticles()
            }
        },

        search: {
            handler() {
                this.page = 1;
                clearTimeout(this.search_timeout);
                this.search_timeout = setTimeout(this.getArticles, 500)
            }
        },

    },

    created() {
        this.getArticles();
        this.getSections();
    },

    methods: {
        ...mapActions('alert', ['success', 'error']),



        seeItem(current_item) {
            this.current_article = this.$clone(current_item);
            this.article_dialog = true;
        },

        getSections() {
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/destinations/sections';

            // prepare params
            let options = {
                params: {
                    size: 50
                }
            };

            // make places search request
            this.$axios.get(endpoint, options)
                .then(response => {
                    this.sections = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {});

        },

        getArticles() {
            // we are currently loading
            this.loading = true;

            // prepare filter for section
            if(!this.filter_section_id) {
                this.filter_section_ids = [];
            } else {
                this.filter_section_ids = [this.filter_section_id];
            }

            //prepare sorting & direction params
            let orders = [];
            let dirs = [];
            if(this.sort_field_item) {
                dirs.push(this.sort_field_dir);
                orders.push(this.sort_field_item);
            } else {
                dirs.push('desc');
                orders.push('created_at')
            }

            // prepare search string
            let search = this.search;
            if(search === '' || search === undefined) {
                search = null;
            }
            // prepare type search filter
            let fields = [];
            this.search_fields.forEach(field => {
                if(field.selected) {
                    fields.push(field.value);
                }
            });

            // prepare stamp & save current_stamp
            let stamp = Date.now();
            this.current_stamp = stamp;

            // setup query params
            let params = {
                params: {
                    search: search,
                    fields: fields,
                    size: this.size,
                    page: this.page,
                    orders: orders,
                    dirs: dirs,
                    stamp: stamp,
                    // operational fields
                    language: this.language,
                    status: this.status,
                    section_ids: this.filter_section_ids,
                    place_ids: this.filter_location_id,
                    user_ids: this.filter_user_ids,
                }
            };

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/destinations/articles';

            this.$axios.get(endpoint, params)
                .then(response => {
                    if(parseInt(this.current_stamp) === parseInt(response.data.meta.stamp)) {
                        this.items = response.data.data;
                        this.total = response.data.pagination.total;
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.error('Oops, something went wrong!');
                })
                .finally(() => {
                    this.loading = false;
                })
        },

        openDeleteModal(item) {
            this.article_dialog = false;
            this.delete_article = item;
            this.delete_dialog = true;
        },

        destroy() {
            this.loading_delete = true;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/destinations/articles/' + this.delete_article.id;

            // call delete endpoint
            this.$axios.delete(endpoint) // eslint-disable-next-line
                .then(response => {
                    this.getArticles();
                    this.success('Article deleted.');
                    this.delete_dialog = false;
                })
                .catch(error => {
                    console.error(error);
                    this.error('Oops, something went wrong!');
                })
                .finally(() => {
                    this.loading_delete = false;
                });
        },

        openCreate() {
            this.item_id = null;
            this.edit_dialog = true;
        },

        openEdit(article) {
            this.item_id = article.id;
            this.edit_dialog = true;
        },

        selectPlace(place) {
            if(place) {
                this.article.place_id = place.id;
            } else {
                this.article.place_id = null;
            }
        },

        filterLocation(location) {
            if(location) {
                this.filter_location_id = [location.id];
            } else {
                this.filter_location_id = [];
            }
            this.filterArticles();
        },

        filterUser(user) {
            if(user) {
                this.filter_user_ids = [user.user_id];
            } else {
                this.filter_user_ids = null
            }
            this.filterArticles();
        },

        filterArticles() {
            this.page = 1;
            this.getArticles();
        },

        sortField(sortItem) {
            this.sort_field_item = sortItem.sort_order;
            this.sort_field_dir = sortItem.sort_dir;
            this.getArticles();
            this.dialog_mobile_sort = false;
        },

        selectField(field) {
            field.selected = !field.selected;
            if(this.search) {
                this.getArticles();
            }
        },

    }

}
</script>

<style>
.v-input__slot {
    margin: 0 !important;
}

table th:focus {
    outline: none;
}
</style>
